import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import CompanyService from '@/core/services/company.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditCompanyComponent extends Vue {

  companyService: any = new CompanyService();
  sidebarService: any = new SidebarService();
  genericErr : any = [];
  businessList: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  // Fields
  name: string = "";
  businessId: number = 1;
  manager: string = "";
  allowedUsers: number = 0;
  logo: any = "";

  mounted (){
    const _ = this;
    _.getById();
    _.getBusiness();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  changeLogo(){
    const _ = this;
    _.logo = new FormData();
    _.logo.append('logo', document.querySelector('.logo').files[0]);
    _.logo.append('name', _.name);
    _.logo.append('businessId', _.businessId);
    _.logo.append('manager', _.manager);
    _.logo.append('allowedUsers', _.allowedUsers);
  }

  getBusiness(){
    const _ = this;
    _.isLoading = true;
    _.companyService.getBusiness().then((data: any) => {
      _.businessList = data['data'].businesses;
      _.businessList.sort(function(a, b) {
         return a.name.localeCompare(b.name);
      })
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      _.isLoading = false;
    })
  }

  edit(){
    const _ = this;
    let company: object;
    let hasLogo = _.logo ? true : false;
    if (hasLogo) {
      company = _.logo;
    } else {
      company = {
        name: _.name,
        businessId: _.businessId,
        manager: _.manager,
        allowedUsers: _.allowedUsers,
      };
      console.log(company, 'company')
    }
    let company_id: any = location.href.split("/");
    company_id = company_id[5];
    _.isLoading = true;
    _.companyService.edit(company, company_id, hasLogo).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/companies');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let company_id: any = location.href.split("/");
    company_id = company_id[5];
    _.isLoading = true;
    _.companyService.getById(company_id).then((data: any) => {
      _.name = data['data'].company.name;
      _.manager = data['data'].company.manager;
      _.allowedUsers = data['data'].company.allowedUsers; 
      _.businessId = data['data'].company.businessId;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(name = '', email = ''){
    const _ = this;
    _.genericErr = [];
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(!emailRegex.test(email.toLowerCase()) && email != ''){
      _.genericErr.push("Correo invalido");
    }
    if(name == ''){
      _.genericErr.push("Por favor escribe el nombre de la compañia");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
